module.exports = __webpack_public_path__ + "static/media/block1.b7ca7e25.png";